import React from 'react';
import PropTypes from 'prop-types';

// Renders one confirmation chapter entry as a title with label/value rows.
const ConfirmationSection = ({ title, rows }) => (
  <li>
    <h4>{title}</h4>
    <ul className="vads-u-padding--0" style={{ listStyle: 'none' }}>
      {rows.map(({ label, value }) => (
        <li key={label}>
          <div className="vads-u-color--gray">{label}</div>
          {Array.isArray(value) ? (
            value.map(item => <div key={item}>{item}</div>)
          ) : (
            <div>{value}</div>
          )}
        </li>
      ))}
    </ul>
  </li>
);

ConfirmationSection.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
      ]),
    }),
  ).isRequired,
  title: PropTypes.string.isRequired,
};

export default ConfirmationSection;
